import app from '../app.first';

app.ListingFilter = class extends app.Component {
	onReady($this) {
		let typingTimer = '';
		let ajaxFilter = $('.ajaxFilter');

		ajaxFilter.on('keyup', function () {
			clearTimeout(typingTimer);
			typingTimer = setTimeout($(this).filterAdminResults, '150');
		});
		ajaxFilter.on('keydown', function () {
			clearTimeout(typingTimer);
		});

		$('.ajaxSelectFilter').on('change', function () {
			$(this).filterAdminResults();
		});

		$("<span class='sort-arrow fa fa-caret-up'></span>").insertAfter("a.asc");
		$("<span class='sort-arrow fa fa-caret-down'></span>").insertAfter("a.desc");

		$.fn.filterAdminResults = function (filter) {
			$('.loaderImage').show();
			var data = {
				search: ajaxFilter.val() || ''
			};

			$('.ajaxSelectFilter').each(function () {
				data[$(this).attr('name')] = $(this).val();
			});


			$.ajax({
				url: '',
				data: data,
				success: function (response) {
					$('.listing').html($(response).find('.listing').html());
					$('.loaderImage').hide();

					// update the url in addressbar
					if (history.pushState) {
						var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + $.param(data);
						window.history.pushState({path:newurl},'',newurl);
					}
				}
			});
		}
	}
}
